import React from "react";
import { NavLink } from "react-router-dom";
import ProjectsCompletedLeft from "./ProjectsCompletedLeft";
import ProjectsCompletedRight from "./ProjectsCompletedRight";

const ProjectsCompleted = () => {
  return (
    <div className="projects">
      <div className="submenu">
        <div>
          <NavLink to="/projects/completed/adiet">Adiet</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/adigrat">Adigrat</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/adishihu">Adishihu</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/adwa">Adwa</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/enticho">Enticho</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/enticho">Egela</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/hagereselam">Hagere Selam</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/mekelle">Mekelle</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/naedier">Naedier</NavLink>
        </div>
        <div>
          <NavLink to="/projects/completed/shire">Shire</NavLink>
        </div>
      </div>

      <div className="main rediet-flex-direction">
        <div>
          <ProjectsCompletedLeft />
        </div>
        <div>
          <ProjectsCompletedRight />
        </div>
      </div>
    </div>
  );
};

export default ProjectsCompleted;
